import React from "react";
import { Link } from "react-router-dom";
import arcades from "../data/arcades";
const imageBase = "/images/arcades";

const Services = () => {
  return (
    <main className="bg-background">
      {/* HERO */}
      <section className="py-24 bg-primary text-primary-foreground">
        <div className="container mx-auto px-4 text-center max-w-5xl">
          <span className="uppercase tracking-widest font-bold opacity-80">
            Event & Convention Support
          </span>

          <h1 className="text-5xl md:text-7xl font-display mt-4 mb-6">
            Services We Offer
          </h1>

          <p className="text-xl max-w-3xl mx-auto opacity-90 font-bold">
            Bring a unique attraction to your convention, festival,
            library event, school program, or community gathering while
            supporting youth literacy throughout Tennessee.  Offering support to events both large and small.
          </p>
        </div>
      </section>

      {/* SERVICES INDEX */}
<section className="py-12 border-b bg-muted">
  <div className="container mx-auto px-4">

    <h2 className="text-2xl font-display text-center mb-8">
      Available Services
    </h2>

    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">

      <a href="#library" className="bg-white rounded-xl border p-4 hover:shadow-md transition">
        📚 Manga Library
      </a>

      <a href="#arcades" className="bg-white rounded-xl border p-4 hover:shadow-md transition">
        🕹️ Arcade Collection
      </a>

      <a href="#matsuri" className="bg-white rounded-xl border p-4 hover:shadow-md transition">
        🎌 Matsuri Activities
      </a>

      <a href="#panels" className="bg-white rounded-xl border p-4 hover:shadow-md transition">
        🎤 Educational Panels
      </a>

      <a href="#workshops" className="bg-white rounded-xl border p-4 hover:shadow-md transition">
        ✂️ Workshops
      </a>

      <a href="#tables" className="bg-white rounded-xl border p-4 hover:shadow-md transition">
        🪑 Table Rentals
      </a>

      <a href="#gacha" className="bg-white rounded-xl border p-4 hover:shadow-md transition">
        🎲 Gacha Machines
      </a>

      <a href="#request" className="bg-white rounded-xl border p-4 hover:shadow-md transition">
        📋 Request Support
      </a>

    </div>

  </div>
</section>

      {/* MANGA LIBRARY */}
      <section id="library" className="py-12">
        <div className="container mx-auto px-4">

          <div className="grid md:grid-cols-2 gap-12 items-center">

            <div>
              <span className="text-primary font-bold uppercase tracking-wider">
                Traveling Manga Library
              </span>

              <h2 className="text-4xl font-display mt-2 mb-6">
                Over 2,000 Manga Titles
              </h2>

              <p className="text-lg text-muted-foreground mb-6">
                We can bring our free-to-read manga library directly to
                your event. Attendees can browse, discover new series,
                and enjoy a welcoming reading space throughout the day.
              </p>

              <ul className="space-y-3">
                <li>✓ 2,000+ manga volumes</li>
                <li>✓ Reading area setup</li>
                <li>✓ Family-friendly attraction</li>
                <li>✓ Great for conventions and festivals</li>
              </ul>
            </div>

            <img
              src="/images/traveling-library.png"
              alt="Traveling Manga Library"
              className="rounded-3xl shadow-xl"
            />
          </div>
        </div>
      </section>

    {/* ARCADES */}
    <section id="arcades" className="py-24 bg-muted">
    <div className="container mx-auto px-4">

        <div className="text-center max-w-5xl mx-auto mb-16">

        <span className="text-primary font-bold uppercase tracking-wider">
            Free Play Arcade Experience
        </span>

        <h2 className="text-4xl md:text-5xl font-display mt-2 mb-6">
            Rare Japanese Arcade Machines
        </h2>

        <p className="text-xl text-muted-foreground">
            A whole host of arcades that can be available for your next event.
        </p>

        </div>

        {/* STATS */}
        <div className="grid md:grid-cols-3 gap-8 mb-16 text-center">

        <div className="bg-background rounded-3xl border p-8">
            <div className="text-5xl font-display text-primary">
            30
            </div>

            <p className="mt-2 font-medium">
            Arcade Machines
            </p>
        </div>

        <div className="bg-background rounded-3xl border p-8">
            <div className="text-5xl font-display text-primary">
            62
            </div>

            <p className="mt-2 font-medium">
            Tomy Gacha Machines
            </p>
        </div>

        <div className="bg-background rounded-3xl border p-8">
            <div className="text-5xl font-display text-primary">
            100%
            </div>

            <p className="mt-2 font-medium">
            Free Play
            </p>
        </div>

        </div>

        {/* FEATURED MACHINES */}
        <div className="bg-background rounded-3xl border shadow-sm overflow-hidden mb-16">
          <div className="grid grid-cols-2 md:grid-cols-3">
            <img src={`${imageBase}/lovelive.jpg`} alt="Love Live!" className="aspect-[4/3] object-cover w-full" />
            <img src={`${imageBase}/ff.jpg`} alt="Final Fantasy Theatrhythm" className="aspect-[4/3] object-cover w-full" />
            <img src={`${imageBase}/danceevo.jpg`} alt="Dance Evolution" className="aspect-[4/3] object-cover w-full" />
            <img src={`${imageBase}/dancerush.jpg`} alt="DanceRush Stardom" className="aspect-[4/3] object-cover w-full" />
            <img src={`${imageBase}/wacca.jpg`} alt="WACCA Reverse" className="aspect-[4/3] object-cover w-full" />
            <img src={`${imageBase}/sdvx.jpg`} alt="Sound Voltex" className="aspect-[4/3] object-cover w-full" />
          </div>
        </div>

          <div className="text-center">
            <p className="text-lg text-muted-foreground mb-8 max-w-3xl mx-auto">
                Our collection includes rhythm games, fighting games, crane
                machines, prize attractions, and rare imported cabinets.
                Every machine is configured for free play.
            </p>

            <Link to="/arcades" className="inline-flex items-center px-8 py-4 rounded-xl bg-primary text-primary-foreground font-semibold hover:opacity-90 transition-opacity">
                View Full Arcade Catalog
            </Link>
          </div>
        
      </div>
    </section>

      {/* CULTURAL ACTIVITIES */}
<section id="cultural" className="py-12">
  <div className="container mx-auto px-4">

    <div className="text-center max-w-5xl mx-auto mb-16">

      <span className="text-primary font-bold uppercase tracking-wider">
        Cultural Programming
      </span>

      <h2 className="text-4xl md:text-5xl font-display mt-2 mb-6">
        Matsuri Activities, Workshops & Panels
      </h2>

      <p className="text-xl text-muted-foreground">
        Our team includes event planners, marketers, game developers,
        entrepreneurs, artists, makers, and builders. Whether you're
        planning a convention, library program, cultural festival, or
        community event, we can help create memorable experiences for
        attendees of all ages.
      </p>

    </div>

    <div className="grid md:grid-cols-3 gap-6 mb-12">

      <div className="bg-white border rounded-2xl p-8 text-center">
        <div className="text-5xl font-display text-primary">
          8
        </div>

        <p className="mt-2 font-bold">
          Festival Stalls
        </p>
      </div>

      <div className="bg-white border rounded-2xl p-8 text-center">
        <div className="text-5xl font-display text-primary">
          Indoor
        </div>

        <p className="mt-2 font-bold">
          Event Ready
        </p>
      </div>

      <div className="bg-white border rounded-2xl p-8 text-center">
        <div className="text-5xl font-display text-primary">
          Outdoor
        </div>

        <p className="mt-2 font-bold">
          Event Ready
        </p>
      </div>

    </div>

    <div className="bg-muted rounded-3xl p-10">

      <h3 className="text-3xl font-bold mb-8">
        Matsuri Activities
      </h3>

      <p className="text-muted-foreground mb-8">
        Some activities may operate as pay-to-play attractions.
        Events may choose to sponsor materials and prize support to
        make activities free for attendees.
      </p>

      <div className="space-y-8">

        <div>
          <h4 className="text-xl font-bold mb-2">
            Kingyo Sukui
          </h4>

          <p className="text-muted-foreground">
            Participants use a delicate paper scoop (poi) to collect
            goldfish or super balls before the paper tears.
          </p>

          <p className="text-sm text-red-600 mt-2">
            Warning: This activity involves water and may not be
            suitable for all venues.
          </p>
        </div>

        <div>
          <h4 className="text-xl font-bold mb-2">
            Yoyo Tsuri
          </h4>

          <p className="text-muted-foreground">
            Players attempt to catch floating water yoyos using a
            fragile paper hook before it breaks.
          </p>

          <p className="text-sm text-red-600 mt-2">
            Warning: This activity involves water and may not be
            suitable for all venues.
          </p>
        </div>

        <div>
          <h4 className="text-xl font-bold mb-2">
            Kitsune Mask Workshop
          </h4>

          <p className="text-muted-foreground">
            Instead of purchasing a premade mask, attendees decorate
            their own blank kitsune mask using provided craft supplies.
          </p>
        </div>

        <div>
          <h4 className="text-xl font-bold mb-2">
            Fumi Fumi
          </h4>

          <p className="text-muted-foreground">
            A fast-paced social game where players attempt to trick
            opponents into making the wrong gestures while following
            the rhythm of a song.
          </p>
        </div>

        <div>
          <h4 className="text-xl font-bold mb-2">
            Tosenkyo
          </h4>

          <p className="text-muted-foreground">
            A traditional party game from the Edo period where players
            use a folding fan to knock targets into different scoring
            positions.
          </p>
        </div>

        <div>
          <h4 className="text-xl font-bold mb-2">
            Senbon Kuji
          </h4>

          <p className="text-muted-foreground">
            A classic festival lottery game where all prizes are
            displayed and participants select a string to discover
            which prize they have won.
          </p>
        </div>

      </div>

    </div>

  </div>
</section>

{/* PANELS */}
<section id="panels" className="py-12 bg-muted">
  <div className="container mx-auto px-4">

    <div className="text-center mb-12">
      <h2 className="text-4xl font-display mb-4">
        Educational Panels
      </h2>

      <p className="text-xl text-muted-foreground">
        Presentations and discussions led by experienced creators,
        business owners, and community leaders.
      </p>
    </div>

    <div className="grid md:grid-cols-3 gap-6">

      <div className="bg-white rounded-2xl p-8 border">
        <h3 className="font-bold text-xl mb-4">
          Indie Game Planning
        </h3>

        <p className="text-muted-foreground">
          Learn the realities of taking a game from concept to release.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-8 border">
        <h3 className="font-bold text-xl mb-4">
          Surviving While Self Employed
        </h3>

        <p className="text-muted-foreground">
          Practical advice from entrepreneurs and independent creators.
        </p>
      </div>

      <div className="bg-white rounded-2xl p-8 border">
        <h3 className="font-bold text-xl mb-4">
          Joining the Artist Alley
        </h3>

        <p className="text-muted-foreground">
          Preparing for conventions, creating inventory, and managing
          expectations as a new vendor.
        </p>
      </div>

    </div>

  </div>
</section>

{/* WORKSHOPS */}
<section id="workshops" className="py-12">
  <div className="container mx-auto px-4">

    <div className="text-center mb-12">
      <h2 className="text-4xl font-display mb-4">
        Hands-On Workshops
      </h2>

      <p className="text-xl text-muted-foreground">
        Every participant leaves with something they created.
      </p>
    </div>

    <div className="grid md:grid-cols-3 gap-6">

      <div className="bg-white border rounded-2xl p-8">
        <h3 className="font-bold text-xl mb-4">
          Amigurumi
        </h3>

        <p className="text-muted-foreground">
          Learn basic crochet techniques while creating a small project.
        </p>
      </div>

      <div className="bg-white border rounded-2xl p-8">
        <h3 className="font-bold text-xl mb-4">
          Sticker Crafting
        </h3>

        <p className="text-muted-foreground">
          Design and create custom stickers to take home.
        </p>
      </div>

      <div className="bg-white border rounded-2xl p-8">
        <h3 className="font-bold text-xl mb-4">
          Photo Card Holders
        </h3>

        <p className="text-muted-foreground">
          Create decorative holders for collectibles, photos, and cards.
        </p>
      </div>

    </div>

  </div>
</section>

      {/* TABLE RENTALS */}
      <section id="tables" className="py-12">
        <div className="container mx-auto px-4">

          <div className="max-w-4xl mx-auto text-center">
            <span className="text-primary font-bold uppercase tracking-wider">
              Equipment Rentals
            </span>

            <h2 className="text-4xl font-display mt-2 mb-6">
              Banquet Table Rentals
            </h2>

            <p className="text-lg text-muted-foreground">
              We have up to 50 banquet tables available for vendor halls,
              artist alleys, registration areas, workshops, and community
              events.
            </p>

            <div className="grid md:grid-cols-3 gap-6 py-10">

              <div className="bg-white border rounded-2xl p-8">
                <div className="text-5xl font-display text-primary">
                  50
                </div>
                <p className="mt-2 font-bold">
                  Tables Available
                </p>
              </div>

              <div className="bg-white border rounded-2xl p-8">
                <div className="text-5xl font-display text-primary">
                  8'
                </div>
                <p className="mt-2 font-bold">
                  Length
                </p>
              </div>

              <div className="bg-white border rounded-2xl p-8">
                <div className="text-5xl font-display text-primary">
                  30"
                </div>
                <p className="mt-2 font-bold">
                  Width
                </p>
              </div>

            </div>
            <Link to="/event-support" className="inline-flex items-center px-8 py-4 rounded-xl bg-primary text-primary-foreground font-semibold hover:opacity-90 transition-opacity">
                Request Event Support
            </Link>
          </div>
        </div>
      </section>

      <section id="gacha"className="py-12">
        <div className="bg-primary/10 border border-primary/20 rounded-3xl p-8 mb-12">
        <h3 className="text-2xl font-bold mb-4">
            Gacha & Prize Attractions
        </h3>

        <p className="text-muted-foreground mb-4">
            In addition to our arcade collection, we maintain a fleet of
            62 authentic Tomy capsule toy machines that can be incorporated
            into conventions, festivals, library programs, and community events.
        </p>

        <p className="text-muted-foreground">
            Gacha machines can be used as standalone attractions, fundraising
            opportunities, prize redemption systems, or to help offset the
            cost of event activities and programming.
        </p>
        </div>
      </section>
       

      {/* NONPROFIT */}
      <section className="py-24 bg-foreground text-background">
        <div className="container mx-auto px-4 text-center max-w-4xl">

          <h2 className="text-4xl md:text-5xl font-display mb-8">
            Every Booking Supports Literacy
          </h2>

          <p className="text-xl mb-6">
            All proceeds directly support the library, literacy
            initiatives, manga collection growth, and community outreach.
          </p>

          <p className="text-lg opacity-80">
            As a 501(c)(3) nonprofit organization, donations made in
            support of our mission are tax deductible as allowed by law.
          </p>
        </div>
      </section>

    </main>
  );
};

export default Services;